import { useToken } from "app/providers/TokenProvider";

export default function useAuth() {
  const token = useToken();

  const isLoggedIn = !!token?.access_token;

  return isLoggedIn;
}
